import React, { useState, useEffect } from 'react';
import { Grid, Drawer, Button, useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Constants } from '../../endPoints';
import Breadcumb from '../../Layouts/Breadcumb';
import Shopsidebar from '../Shopsidebar/Shopsidebar';
import { jwtDecode } from 'jwt-decode';
import { useHistory, useLocation } from "react-router-dom";
import MobileAppSection from '../Home/MobileApp';
import NoProductFound from '../NoProductFound';

const countryCurrencySymbols = {
  Algeria: 'DA',
  Argentina: 'ARS',
  Australia: 'AUD',
  Austria: '€',
  Bahrain: 'BHD',
  Brazil: 'BRL',
  Canada: 'CA$',
  Egypt: 'EGP',
  Ethiopia: 'ETB',
  France: '€',
  Germany: '€',
  India: '₹',
  Iraq: 'IQD',
  Italy: '€',
  Jordan: 'JOD',
  Kuwait: 'KWD',
  Lebanon: 'LBP',
  Libya: 'LYD',
  Malaysia: 'MYR',
  Morocco: 'MAD',
  Oman: 'OMR',
  Pakistan: '₨',
  Philippines: '₱',
  Qatar: 'QAR',
  'Saudi Arabia': 'SAR',
  'South Africa': 'R',
  Spain: '€',
  Sudan: 'SDG',
  Syria: 'SYP',
  Tunisia: 'TND',
  Turkey: '₺',
  'United Arab Emirates': 'AED',
  'United Kingdom': '£',
  'United States': '$',
  default: '$', // Fallback for unknown countries
};

const renderStars = (rating) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 >= 0.5;

  const stars = [];

  for (let i = 0; i < fullStars; i++) {
    stars.push(<i key={`full-${i}`} className="fa-solid fa-star text-orange-400 mr-1"></i>);
  }

  if (halfStar) {
    stars.push(<i key="half" className="fa-regular fa-star-half-stroke text-orange-400 mr-1"></i>);
  }

  while (stars.length < 5) {
    stars.push(<i key={`empty-${stars.length}`} className="fa-regular fa-star text-orange-400 mr-1"></i>);
  }

  return stars;
};


export default function Listing() {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(12);
  const [keyword, setKeyword] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const [pagination, setPagination] = useState(null);
  const [productImages, setProductImages] = useState({});
  const [accessToken, setAccessToken] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [wishlist, setWishlist] = useState([]);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [feedbackType, setFeedbackType] = useState('');
  // const [countryName, setCountryName] = useState('');
  const [countryName, setCountryName] = useState([]);
  const [selectionName, setSelectionName] = useState([]);
  // const [categoryName, setCategoryName] = useState('');
  const [categoryName, setCategoryName] = useState([]);
  const [shopForName, setShopForName] = useState([]);
  const [openmobileFilter, setOpenmobileFilter] = useState(false);
  const [sortOrder, setSortOrder] = useState("default");
  const history = useHistory();


  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('authToken');
    if (token) {
      setAccessToken(token);
      setIsLoggedIn(true);
      fetchUserWishlist(token);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const fetchUserWishlist = async (token) => {
    const decodedToken = jwtDecode(token);
    const idUser = decodedToken.id;

    try {
      const response = await axios.get(`${Constants.getUserWishlist}/${idUser}`);
      console.log('API Response:', response.data);

      if (response.data.status === 1) {
        const wishlistProductIds = response.data.list.map((item) => item.idProduct);
        setWishlist(wishlistProductIds);
      }
    } catch (error) {
      console.error('Error fetching user wishlist:', error);
    }
  };

  const location = useLocation();
  const [openFilter, setOpenFilter] = useState(false);
  const isMobile = useMediaQuery('(max-width:768px)');
  const [hasActiveFilter, setHasActiveFilter] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  // console.log('API Response url:', queryParams);
  const idCountry = queryParams.get("country") || "";
  // console.log('list API Response idCountry:', idCountry);
  const idCategory = queryParams.get("category") || "";
  const idSelection = queryParams.get("selection") || "";
  const idShopFor = queryParams.get("shopFor") || "";
  const idRingStyle = queryParams.get("ringStyle") || "";
  const idPearlColor = queryParams.get("pearlColor") || "";
  const idPearlType = queryParams.get("pearlType") || "";
  const idDiamondColor = queryParams.get("diamondColor") || "";
  const idClarity = queryParams.get("clarity") || "";
  const idStoneColor = queryParams.get("stoneColor") || "";

  const fetchProducts = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${Constants.listProduct}?page=${currentPage}&limit=${limit}&keyword=${keyword}&idCountry=${idCountry}&idCategory=${idCategory}&idSelection=${idSelection}&idShopFor=${idShopFor}&idRingStyle=${idRingStyle}&idPearlColor=${idPearlColor}&idPearlType=${idPearlType}&idDiamondColor=${idDiamondColor}&idClarity=${idClarity}&idStoneColor=${idStoneColor}`
      );

      if (response.data.status === 1) {

        let activeProducts = response.data.list.filter(
          product =>
            product.status === 'Active' &&
            Number(product.is_approved) === 1
        );

        // FRONTEND SORTING
        if (sortOrder === "asc") {
          activeProducts = activeProducts.sort((a, b) =>
            a.selectionName.localeCompare(b.selectionName)
          );
        }

        setProducts(activeProducts);

        await fetchImagesForProducts(activeProducts);
        setTotalPages(response.data.pagination.totalPages);
        setPagination(response.data.pagination);
      } else {
        setProducts([]);
      }

    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setIsLoading(false);
    }
  };


  //Added fetchImagesForProducts(activeProducts); to fetch producted and commeneted this code.

  // useEffect(() => {
  //   if (products.length > 0) {
  //     fetchImagesForProducts(products);
  //   }
  // }, [products]); // Ensure this only runs when products change

  const fetchImagesForProducts = async (products) => {
    const images = {};
    try {
      await Promise.all(
        products.map(async (product) => {
          try {
            const response = await axios.get(`${Constants.getProductImagesById}/${product.id}`);

            if (response.data.status === 1 && response.data.data.length > 0) {
              const firstImage = response.data.data[0];
              images[product.id] = firstImage;
            } else {
              // 👇 Fallback for missing image
              images[product.id] = { image: 'product_default.png' };
            }

          } catch (error) {
            console.error(`Error fetching image for product ${product.id}:`, error);
            // 👇 Even if request fails, set default image
            images[product.id] = { image: 'product_default.png' };
          }
        })
      );

      console.log('Fetched product images:', images);
      setProductImages(images);

    } catch (error) {
      console.error('Error fetching product images:', error);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [location.search, currentPage, limit, keyword, sortOrder]);

  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1); // Reset to the first page on search
    fetchProducts();
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    // If there's a feedback message, set a timeout to hide it after 10 seconds
    if (feedbackMessage) {
      const timer = setTimeout(() => {
        setFeedbackMessage('');
        setFeedbackType('');
      }, 5000); // 10 seconds

      // Clear the timer if feedbackMessage changes before the timeout
      return () => clearTimeout(timer);
    }
  }, [feedbackMessage]);

  useEffect(() => {
    if (feedbackMessage) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [feedbackMessage]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, [currentPage]);

  const handleWishlistClick = async (productId) => {
    if (!isLoggedIn) {
      setFeedbackMessage('Please log in to modify your wishlist.');
      setFeedbackType('error');
      return;
    }

    const decodedToken = jwtDecode(accessToken);
    const idUser = decodedToken.id;

    try {
      if (isProductInWishlist(productId)) {
        // 🔴 Remove from wishlist
        const response = await axios.delete(`${Constants.deleteFromWishlist}/${productId}`, {
          data: {
            idUser,
            idProduct: productId,
          },
        });

        if (response.data.status === 1) {
          setWishlist(prev => prev.filter(id => id !== productId));
          setFeedbackMessage('Removed from wishlist');
          setFeedbackType('success');
        } else {
          setFeedbackMessage(response.data.message || 'Failed to remove from wishlist.');
          setFeedbackType('error');
        }

      } else {
        // ✅ Add to wishlist
        const response = await axios.post(`${Constants.addToWishlist}`, {
          idUser,
          idProduct: productId,
        });

        if (response.data.status === 1) {
          setWishlist(prev => [...prev, productId]);
          setFeedbackMessage('Product added to wishlist!');
          setFeedbackType('success');
        } else {
          setFeedbackMessage(response.data.message || 'Failed to add to wishlist.');
          setFeedbackType('error');
        }
      }
    } catch (error) {
      console.error('Wishlist error:', error);
      setFeedbackMessage('An error occurred.');
      setFeedbackType('error');
    }
  };

  const isProductInWishlist = (productId) => {
    return wishlist.includes(productId); // Check if the productId exists in the wishlist
  };

  // const fetchCountryNames = async (countryIds) => {
  //   try {
  //     const countryPromises = countryIds.map(async (id) => {
  //       const response = await axios.get(`${Constants.getCountryById}/${id}`);
  //       return response.data.data.country;
  //     });
  //     const countries = await Promise.all(countryPromises);
  //     setCountryName(countries);
  //   } catch (error) {
  //     console.error('Error fetching countries:', error);
  //   }
  // };

  const fetchCountryNames = async (countryIds) => {
    try {
      const countries = await Promise.all(
        countryIds.map(async (id) => {
          const res = await axios.get(`${Constants.getCountryById}/${id}`);
          return {
            id: id,
            name: res.data.data.country
          };
        })
      );

      setCountryName(countries);
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch selection name based on idSelection
  const fetchSelectionName = async (selectionIds) => {
    try {
      const selections = await Promise.all(
        selectionIds.map(async (id) => {
          const res = await axios.get(`${Constants.getSelectionById}/${id}`);
          return {
            id,
            name: res.data.data.name
          };
        })
      );

      setSelectionName(selections);
    } catch (error) {
      console.error(error);
    }
  };

  // const fetchCategoryName = async (idCategory) => {
  //   try {
  //     const response = await axios.get(`${Constants.getCategoryById}/${idCategory}`);
  //     if (response.data.status === 1) {
  //       setCategoryName(response.data.data.name); // Assuming response contains the selection name in 'name' field
  //     }
  //   } catch (error) {
  //     console.error("Error fetching Category:", error);
  //   }
  // };

  const fetchCategoryName = async (categoryIds) => {
    try {
      const categories = await Promise.all(
        categoryIds.map(async (id) => {
          const res = await axios.get(`${Constants.getCategoryById}/${id}`);
          return {
            id,
            name: res.data.data.name
          };
        })
      );

      setCategoryName(categories || []); // ✅ always array
    } catch (error) {
      console.error("Error fetching Category:", error);
      setCategoryName([]); // ✅ fallback
    }
  };

  const fetchShopForName = async (idShopFor) => {
    try {
      const ids = idShopFor.split(",");

      const results = await Promise.all(
        ids.map(async (id) => {
          const res = await axios.get(`${Constants.getShopForById}/${id}`);
          return {
            id,
            name: res.data.data.name
          };
        })
      );

      setShopForName(results); // ✅ store array
    } catch (error) {
      console.error(error);
    }
  };


  useEffect(() => {
    if (idCountry) {
      const countryIds = idCountry.split(',');
      fetchCountryNames(countryIds);
    }
    if (idSelection) {
      const selectionIds = idSelection.split(',');
      fetchSelectionName(selectionIds);
    }
    if (idCategory) {
      const categoryIds = idCategory.split(",");
      fetchCategoryName(categoryIds);
    }
    if (idShopFor) {
      fetchShopForName(idShopFor);
    }
  }, [idCountry, idSelection, idCategory, idShopFor]);

  // const handleRemoveCountry = (countryToRemove) => {
  //   const url = new URL(window.location);
  //   const params = new URLSearchParams(url.search);

  //   // Get all current selected countries
  //   let countries = params.get('country')?.split(',') || [];

  //   // Remove the selected country
  //   countries = countries.filter(country => country !== countryToRemove);

  //   // Update the URL
  //   if (countries.length > 0) {
  //     params.set('country', countries.join(','));
  //   } else {
  //     params.delete('country');
  //   }

  //   url.search = params.toString();
  //   window.history.pushState({}, '', url.toString());

  //   // Update the state (countryName)
  //   if (countries.length > 0) {
  //     fetchCountriesFromAPI(countries); // Use the renamed function
  //   } else {
  //     setCountryName(''); // Reset if no countries are selected
  //   }

  //   // Fetch products based on the updated filters
  //   fetchProducts();
  // };

  const handleRemoveCountry = (countryIdToRemove) => {
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);

    let countries = params.get('country')?.split(',') || [];

    // countries = countries.filter(id => id !== countryIdToRemove);
    countries = countries.filter(id => id !== String(countryIdToRemove));

    if (countries.length > 0) {
      params.set('country', countries.join(','));
    } else {
      params.delete('country');
    }

    url.search = params.toString();
    history.push({
      pathname: location.pathname,
      search: params.toString()
    });

    // update UI instantly
    setCountryName(prev => prev.filter(c => c.id !== countryIdToRemove));

    fetchProducts();
  };
  const fetchCountriesFromAPI = async (countryIds) => {
    try {
      const countryPromises = countryIds.map(async (id) => {
        const response = await axios.get(`${Constants.getCountryById}/${id}`);
        return response.data.data.country;
      });
      const countries = await Promise.all(countryPromises);
      setCountryName(countries); // Update country names
    } catch (error) {
      console.error('Error fetching countries:', error);
    }
  };

  // const handleRemoveSelection = (selectionIdToRemove) => {
  //   const params = new URLSearchParams(location.search);

  //   let selections = params.get('selection')?.split(',') || [];

  //   selections = selections.filter(id => id !== String(selectionIdToRemove));

  //   if (selections.length > 0) {
  //     params.set('selection', selections.join(','));
  //   } else {
  //     params.delete('selection');
  //   }

  //   history.push({
  //     pathname: location.pathname,
  //     search: params.toString()
  //   });
  // };

  const handleRemoveSelection = (selectionIdToRemove) => {
    const params = new URLSearchParams(location.search);

    let selections = params.get('selection')?.split(',') || [];

    selections = selections.filter(id => id !== String(selectionIdToRemove));

    if (selections.length > 0) {
      params.set('selection', selections.join(','));
    } else {
      params.delete('selection');
    }

    history.push({
      pathname: location.pathname,
      search: params.toString()
    });

    // ✅ UPDATE UI STATE IMMEDIATELY
    setSelectionName(prev =>
      prev.filter(item => item.id !== selectionIdToRemove)
    );

    fetchProducts();
  };

  // const handleRemoveCategory = () => {
  //   const url = new URL(window.location);
  //   const params = new URLSearchParams(url.search);
  //   params.delete('category');
  //   url.search = params.toString();
  //   // window.history.pushState({}, '', url.toString());
  //   history.push({
  //     pathname: location.pathname,
  //     search: params.toString()
  //   });


  //   // Update state for selection
  //   setCategoryName('');
  //   // Optionally, store in localStorage/sessionStorage
  //   localStorage.removeItem('category');
  //   fetchProducts();
  // };


  const handleRemoveCategory = (categoryIdToRemove) => {
    const params = new URLSearchParams(location.search);

    let categories = params.get('category')?.split(',') || [];

    categories = categories.filter(id => id !== String(categoryIdToRemove));

    if (categories.length > 0) {
      params.set('category', categories.join(','));
    } else {
      params.delete('category');
    }

    history.push({
      pathname: location.pathname,
      search: params.toString()
    });

    setCategoryName(prev => prev.filter(c => c.id !== categoryIdToRemove));

    fetchProducts();
  };
  const handleRemoveShopFor = (idToRemove) => {
    const params = new URLSearchParams(location.search);

    let values = params.get("shopFor")?.split(",") || [];

    values = values.filter((id) => id !== String(idToRemove));

    if (values.length > 0) {
      params.set("shopFor", values.join(","));
    } else {
      params.delete("shopFor");
    }

    history.push({
      pathname: location.pathname,
      search: params.toString()
    });

    // update UI instantly
    setShopForName((prev) =>
      prev.filter((item) => item.id !== idToRemove)
    );
  };


  const handleClearAll = () => {
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);

    // Remove all query parameters
    params.delete('country');
    params.delete('selection');
    params.delete('category');
    params.delete('shopFor');

    url.search = params.toString();
    window.history.pushState({}, '', url.toString()); // Update the URL without reloading the page

    // Clear all states
    setCountryName([]);
    setSelectionName([]);
    setCategoryName('');
    setShopForName([]);

    // Optionally, store in localStorage/sessionStorage
    localStorage.removeItem('country');
    localStorage.removeItem('selection');
    localStorage.removeItem('category');
    localStorage.removeItem('shopFor');


    // Reload the page to reflect the cleared filters
    window.location.reload();
  };
  useEffect(() => {
    // Check localStorage for saved values
    const storedCountry = localStorage.getItem('country');
    const storedSelection = localStorage.getItem('selection');
    const storedCategory = localStorage.getItem('category');
    const storedShopFor = localStorage.getItem('shopFor');

    if (storedCountry) {
      setCountryName(storedCountry);
    }

    if (storedSelection) {
      setSelectionName(storedSelection);
    }
    if (storedCategory) {
      try {
        const parsed = JSON.parse(storedCategory);
        setCategoryName(Array.isArray(parsed) ? parsed : []);
      } catch {
        setCategoryName([]);
      }
    }
    if (storedShopFor) {
      setShopForName(storedShopFor);
    }
  }, []);

  // const hasFilters =
  //   countryName.length > 0 ||
  //   selectionName.length > 0 ||
  //   categoryName !== "" ||
  //   shopForName !== "";

  const hasFilters =
    countryName.length > 0 ||
    selectionName.length > 0 ||
    categoryName.length > 0 ||
    shopForName.length > 0;

  return (
    <>
      <div className="listingItemMenu">
        <ul>
          {/* <li><a href="#"
            onClick={(e) => {
              e.preventDefault();
              setSortOrder("asc");
            }}><i>
              <img src={`${process.env.PUBLIC_URL}/assets/images/filter_icn1.svg`} alt="" />
            </i> Default Sorting</a></li> */}
          {/* <li><a href="javascript:void(0)" className="openflter"><i><img src="assets/images/filter_icn2.svg" alt="" /></i>Sort by Filter (2)</a></li> */}
          <li>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setOpenFilter(prev => !prev);
              }}
              className="openflter"
            >
              {/* <i><img src="assets/images/filter_icn2.svg" alt="" /></i> */}
              <i><img style={{ width: "20px", height: "20px" }} src={`${process.env.PUBLIC_URL}/assets/images/filter_icn2.svg`} alt="" /></i>
              Filter
            </a>
          </li>
        </ul>
      </div>
      <div className="bannerSec">
        <div className="container">
          <p id="breadcrumbs">
            <span>
              <span>
                <Link to="/">Home</Link>
              </span>
              <span
                className="breadcrumb_last"
                aria-current="page"
              >
                Sell
              </span>
            </span>
          </p>
        </div>
      </div>

      {/* <div className="listingSec"> */}
      <div className={`listingSec ${openFilter ? "filter-open" : ""}`}>
        <div className="container">
          <div className="row">
            {/* LEFT FILTER SIDEBAR */}
            <div className="col-lg-3">
              <div className={`listingleft ${isMobile && !openFilter ? "mobile-hidden" : ""}`}>
                <div className="moblehdng">
                  <h2>Filter</h2>
                  <a
                    href="javascript:void(0)"
                    className="clearlnks"
                    onClick={handleClearAll}
                  >
                    Clear All
                  </a>
                </div>

                {/* Keep your existing filter component */}
                <Shopsidebar
                  onFilterChange={(status) => {
                    const anyActive = Object.values(status).some(Boolean);
                    setHasActiveFilter(anyActive);
                  }}
                  onClose={() => setOpenFilter(false)}
                />
              </div>
            </div>

            {/* RIGHT PRODUCT LIST */}
            <div className="col-lg-9">
              <div className="listingrght" style={{ position: "relative" }}>

                <Link to="/" className="backhomelnk">
                  <span className="icon-Arrow-2"></span>Back to Home
                </Link>

                {/* Selected Filters */}

                <div className="filter-container">
                  {countryName.map((country, index) => (
                    <span key={index} className="filter-tag">
                      <span>{country.name}</span>

                      <button
                        onClick={() => handleRemoveCountry(country.id)}
                        className="remove-btn"
                      >
                        ✕
                      </button>
                    </span>
                  ))}

                  {selectionName.map((item, index) => (
                    <span key={index} className="filter-tag">
                      <span>{item.name}</span>
                      <button
                        onClick={() => handleRemoveSelection(item.id)}
                        className="remove-btn"
                      >
                        ✕
                      </button>
                    </span>
                  ))}

                  {(Array.isArray(categoryName) ? categoryName : []).map((cat) => (
                    <span key={cat.id} className="filter-tag">
                      <span>{cat.name}</span>
                      <button onClick={() => handleRemoveCategory(cat.id)} className="remove-btn">✕</button>
                    </span>
                  ))}

                  {shopForName.map((item) => (
                    <span key={item.id} className="filter-tag">
                      <span>{item.name}</span>
                      <button
                        onClick={() => handleRemoveShopFor(item.id)}
                        className="remove-btn"
                      >
                        ✕
                      </button>
                    </span>
                  ))}

                  {hasFilters && (
                    <button className="clear-btn" onClick={handleClearAll}>
                      Clear All
                    </button>
                  )}
                </div>

                {/* Pagination page */}

                {/* <div className="flex gap-3 mb-5 justify-between items-center">
                  <div className="capitalize text-sm text-gray-600">
                    Showing all {products.length} of {pagination?.totalItems || 0} results
                  </div>

                  <select
                    className="px-3 py-2 border border-gray-500 text-sm min-w-32"
                    value={limit}
                    onChange={(e) => setLimit(Number(e.target.value))}
                  >
                    <option value={10}>10 per page</option>
                    <option value={20}>20 per page</option>
                    <option value={50}>50 per page</option>
                  </select>
                </div> */}

                {feedbackMessage && (
                  <div
                    style={{
                      marginTop: "16px",
                      padding: "16px",
                      textAlign: "center",
                      borderRadius: "6px",
                      backgroundColor: feedbackType === "success" ? "#d1fae5" : "#fee2e2",
                      color: feedbackType === "success" ? "#047857" : "#b91c1c",
                      fontSize: "14px",
                      fontWeight: "500"
                    }}
                  >
                    {feedbackMessage}
                  </div>
                )}

                {isLoading && (
                  <div className="product-loader">
                    <div className="golden-spinner"></div>
                  </div>
                )}

                {!isLoading && products.length === 0 ? (
                  // <p>No products found.</p>
                  <NoProductFound />
                ) : !isLoading && (
                  <div className="row">

                    {products.map((product) => (
                      <div key={product.id} className="col-lg-4 col-6">
                        <div className="productItem">

                          {/* PRODUCT IMAGE */}
                          <div className="productimg">
                            <Link
                              to={`/details/${product.id}`}
                              className="showProduct"
                            >
                              {productImages[product.id] ? (
                                <img
                                  src={`${Constants.imageBaseURL}${productImages[product.id]?.image}`}
                                  alt={product.selectionName}
                                />
                              ) : (
                                <img src="/no-image.png" alt="No Image" />
                              )}
                            </Link>

                            <Link
                              to={`/details/${product.id}`}
                              className="onProduct"
                            >
                              <img
                                src={`${Constants.imageBaseURL}${productImages[product.id]?.image}`}
                                alt=""
                              />
                            </Link>

                            {/* Wishlist / Cart */}
                            <ul className="productlink">
                              <li>
                                <a
                                  onClick={() => handleWishlistClick(product.id)}
                                >
                                  {/* <img
                                    src="assets/images/heart.svg"
                                    alt="wishlist"
                                  /> */}
                                  <li>
                                    {/* <a onClick={() => handleWishlistClick(product.id)}> */}
                                    <a>
                                      <img
                                        src={`${process.env.PUBLIC_URL}/assets/images/heart.svg`}
                                        alt="wishlist"
                                        style={{
                                          filter: isProductInWishlist(product.id)
                                            ? "invert(18%) sepia(97%) saturate(7491%) hue-rotate(357deg) brightness(95%) contrast(110%)"
                                            : "none",
                                          transition: "all 0.3s ease"
                                        }}
                                      />
                                    </a>
                                  </li>
                                </a>
                              </li>
                              {/* <li>
                                <a>
                                  <img src={`${process.env.PUBLIC_URL}/assets/images/cart.svg`} alt="cart" />
                                </a>
                              </li> */}
                            </ul>
                          </div>

                          {/* PRODUCT DETAILS */}
                          <div className="productCot">
                            <div className="itemloctn">
                              <em>
                                <i>
                                  {/* <img
                                    src="assets/images/locatinIcn.svg"
                                    alt=""
                                  /> */}
                                  <img src={`${process.env.PUBLIC_URL}/assets/images/locatinIcn.svg`} alt="" />
                                </i>
                                {product.countryName}, {product.stateName}
                              </em>

                              <strong>
                                <i>
                                  {/* <img
                                    src="assets/images/smailIcn.svg"
                                    alt=""
                                  /> */}
                                  <img src={`${process.env.PUBLIC_URL}/assets/images/smailIcn.svg`} alt="" />
                                </i>
                                {product.rating || 0}
                              </strong>
                            </div>

                            <h3>
                              {product.selectionName}
                            </h3>

                            <span>Category: {product?.categoryName || 'Uncategorized'}</span>

                            {/* <span>
                              {countryCurrencySymbols.default} {product.price}
                            </span> */}
                          </div>
                        </div>
                      </div>
                    ))}

                  </div>
                )}
              </div>
              {/* PAGINATION */}
              {/* <div className="listloder text-center">
                {[...Array(totalPages)].map((_, index) => (
                  <button
                    key={index}
                    className={`mx-1 ${currentPage === index + 1 ? "active" : ""
                      }`}
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </button>
                ))}
              </div> */}
              {/* <div className="listloder">
                <a href="#url"><i>
                  <img src={`${process.env.PUBLIC_URL}/assets/images/loader.png`} alt="" />
                </i>Load More</a>
              </div> */}

              {/* PAGINATION */}
              {totalPages > 1 && !isLoading && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "6px",
                    marginTop: "30px",
                    flexWrap: "wrap"
                  }}
                >

                  {/* PREVIOUS BUTTON */}
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(prev => prev - 1)}
                    style={{
                      padding: "8px 14px",
                      border: "1px solid #ccc",
                      background: currentPage === 1 ? "#eee" : "#fff",
                      cursor: currentPage === 1 ? "not-allowed" : "pointer"
                    }}
                  >
                    Prev
                  </button>

                  {/* PAGE NUMBERS */}
                  {[...Array(totalPages)].map((_, index) => {
                    const page = index + 1;

                    return (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        style={{
                          padding: "8px 14px",
                          border: "1px solid #ccc",
                          background: currentPage === page ? "#A27800" : "#fff",
                          color: currentPage === page ? "#fff" : "#000",
                          cursor: "pointer"
                        }}
                      >
                        {page}
                      </button>
                    );
                  })}

                  {/* NEXT BUTTON */}
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(prev => prev + 1)}
                    style={{
                      padding: "8px 14px",
                      border: "1px solid #ccc",
                      background: currentPage === totalPages ? "#eee" : "#fff",
                      cursor: currentPage === totalPages ? "not-allowed" : "pointer"
                    }}
                  >
                    Next
                  </button>

                </div>
              )}
            </div>
          </div>
        </div>

      </div>
      <MobileAppSection />
    </>
  )
}
